import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Tooltip } from '@material-ui/core';
import { AddRounded, CheckRounded, CloseRounded, DeleteRounded, AddBoxRounded, CheckBoxRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size } from 'lodash';
import ClientPopUp from '../clients/ClientPopUp';
import DeleteDialogConfirm from '../../../../commonModules/interface/DeleteDialogConfirm';
import { toast } from 'react-toastify';

class ListInstall extends Component {
    state = { 
        breadcrumb: "",

        deletePopUp: false,
        toDeleteClient:"",
        toDelete:{
            id:"",
        },
       
        view: "list",
        clientPopUp: false,
        client:{}

    }
    componentDidMount = () => {
        console.log("MOUNTING ListInstalls ");
    }
    
    createInstallList = (list) => {
        const { SHOPS, CLIENTS, rowsPerPage, currentPage } = this.props

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(install => {
            if(install){ // need to check after delete install/prepa to prevent error
                const client = CLIENTS[install.client_ref]
                let client_name = client ? `${client.client_firstname} ${client.client_lastname}` : ""
                const shop = SHOPS[install.shop_id]
                // console.log({install, shop, client});
                return (        
                    <TableRow key={install.id}>
                        {/* <td>{install.id}</td> */}
                        <TableCell>{(new Date(install.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                        {shop ? (
                            <a href="#" onClick={
                                () => this.props.handleSingleShop(shop) 
                                }
                            > {shop.name} </a>
                        ) : (
                            <span>{install.shop_id}</span>
                        )}
                        </TableCell>
                        <TableCell>{client && 
                            <a href="#" onClick={
                                () => this.setState({
                                    client,
                                    clientPopUp: true
                                })
                                }>{client_name}</a> 
                            }</TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={
                                () => this.props.handleSingleInstall(install, shop, client)
                            }>
                                <AddRounded />
                            </IconButton>
                            
                        </TableCell>
                        
                        <TableCell>
                            <Tooltip placement="top" title="Compléter">
                                <IconButton 
                                    onClick={() => this.props.handleInstallToSale(install, client)}
                                >
                                    <CheckBoxRounded color="primary" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell>
                            <Tooltip placement="top" title="Annuler">
                                <IconButton 
                                    onClick={()=> this.setState({
                                        toDelete: install,
                                        toDeleteClient: client_name,
                                        deletePopUp : true
                                    })
                                    }
                                >
                                    <CloseRounded color="error" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                )
            }
        })        
    }  
    
    displayList = () => {
        const { INSTALLS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(INSTALLS)){
            let filteredList = this.props.getFilteredList()
            rows = size(filteredList)
            tab = this.createInstallList(filteredList)
        }
        return [tab, rows]
    }  
        
    deleteInstall = async (comments) => {
        let data = {
            op_id: this.state.toDelete.id,
            comments
        }
        this.props.deleteInstall(data)
        if(this.props.STATE.installs.error){
            console.log("[ERROR] delete install", this.props.STATE.installs.error); 
            toast.error(  "Un Problème est survenu")
        } else {
            toast.success( "Installation supprimée avec succès")
            this.setState({
                deletePopUp:false,
                toDelete:{id: ""},
            })
        }  
    }

    render() {
        const { view } = this.state;
        let installList = this.displayList()

        console.log('====================================');
        console.log("[STATE] LIST INSTALL", this.state);
        console.log('====================================');

        return (
            <React.Fragment>
                {this.state.deletePopUp &&
                    <DeleteDialogConfirm
                        open={true}
                        close={()=>this.setState({deletePopUp: false})}
                        title={"l'installation pour "+ this.state.toDeleteClient}
                        handleSubmit={this.deleteInstall}
                        disabledSubmit={this.props.STATE.installs.fetching}
                    />
                }
                {this.state.clientPopUp && !isEmpty(this.state.client) &&
                    <ClientPopUp 
                        client={this.state.client}
                        {...this.props}
                        closePopUp={() => this.setState({clientPopUp:false, client:{}}) }
                    />
                }
                
                { view === "list" &&
                    <Box>
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Nom Client</TableCell>
                                    <TableCell>Détails</TableCell>
                                    <TableCell>Compléter</TableCell>
                                    <TableCell>Annuler</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { installList[1] !== 0  && 
                                    installList[0]
                                }
                                { installList[1] === 0  && 
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <div className="text-center">
                                            <h5>Pas encore de Installation</h5> 
                                            Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer une nouvelle Installation
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            { installList[1] > 20  && 
                                <TableFooterPagination 
                                    colSpan={7}
                                    count={installList[1]}
                                    onChangePage={this.props.onChangePage}
                                    initialPage={this.props.currentPage || 0}
                                    page={this.props.currentPage}
                                />         
                            }           
                        </ListLayout>
                    </Box>
                }
            </React.Fragment>
        );
    }
}


export default ListInstall;